import React from 'react';
import './StartCurtain.css';
import { ARCHIVE_LINK_VISIBLE } from '../hooks/usePuzzleDateParam';

/**
 * Shown in place of the board until the player starts.
 *
 * The instructions modal used to open on every load, and gating it behind a
 * first visit lost something the wall was quietly doing: it kept the grid,
 * clues and letter tiles out of sight until the clock was running. Without it
 * a player could study the puzzle for as long as they liked at 00:00, work out
 * the answers, and only then click — which is strictly worse for the
 * leaderboard than the old behaviour, where dismissing the modal started the
 * timer immediately.
 *
 * This restores the curtain without restoring the wall: one tap, no reading
 * required, and the how-to-play is a link rather than a gate. First-time
 * visitors get a small pointer at that link instead of a full-screen modal —
 * the rules are one tap away for anyone who wants them, and out of the way for
 * everyone who does not.
 *
 * The board is *not rendered at all* behind this, rather than covered — there
 * is no peeking at the DOM. (The answers do arrive in the payload, so this
 * stops honest players getting an accidental head start; it is not an
 * anti-cheat measure, and nothing client-side could be.)
 */
const StartCurtain = ({
  date, alreadyPlayed, isFirstTime, isArchive, onStart, onShowInstructions, onShowArchive,
}) => (
  <div className="start-curtain">
    <p className="start-curtain-date">
      {isArchive && <span className="start-curtain-badge">Archive</span>}
      {date}
    </p>
    <h1 className="start-curtain-title">
      Jumble<span>Cross</span>
    </h1>
    <p className="start-curtain-tagline">
      You have the clues and the letters, figure out where they go!
    </p>

    {isArchive && (
      <p className="start-curtain-note">Archive puzzles aren&apos;t ranked.</p>
    )}

    {!isArchive && alreadyPlayed && (
      <p className="start-curtain-note">You&apos;ve already played today — this won&apos;t be re-ranked.</p>
    )}

    <button type="button" className="start-curtain-play" onClick={onStart} autoFocus>
      Play
    </button>

    {isFirstTime && (
      <p className="start-curtain-firsttime">First time? Start here <span aria-hidden="true">↓</span></p>
    )}

    <div className="start-curtain-links">
      <button
        type="button"
        className={`start-curtain-help${isFirstTime ? ' start-curtain-help-nudge' : ''}`}
        onClick={onShowInstructions}
      >
        How to play
      </button>
      {ARCHIVE_LINK_VISIBLE && (
        <button type="button" className="start-curtain-help" onClick={onShowArchive}>
          Past puzzles
        </button>
      )}
    </div>
  </div>
);

export default StartCurtain;
